export default __webpack_public_path__ + "static/media/641.c5c03eb9.png";